"use client";
import { addAncestorMarkCleanup, addElementMarkCleanup, isElementInside, isElementMarked, markAncestor, markElement, markTreeInside, restoreCleanups } from "./tree-cleanup.js";
import { walkTreeOutside } from "./walk-tree-outside.js";
//#region src/dialog/utils/mark-tree-outside.ts
function markTreeOutside(id, elements) {
	const cleanups = [];
	const ids = elements.map((el) => el?.id);
	walkTreeOutside(id, elements, (element) => {
		addElementMarkCleanup({
			cleanups,
			element,
			id,
			ids
		});
	}, (ancestor, element) => {
		addAncestorMarkCleanup({
			cleanups,
			ancestor,
			element,
			id
		});
	});
	const restoreAccessibilityTree = () => {
		restoreCleanups(cleanups);
	};
	return restoreAccessibilityTree;
}
//#endregion
export { isElementInside, isElementMarked, markAncestor, markElement, markTreeInside, markTreeOutside };

//# sourceMappingURL=mark-tree-outside.js.map